import VictimProtectedRoute from 'pages/VictimeForm/Route/VictimProtectedRoute'
import React from 'react'
import { lazy } from 'react'

const VictimFormLogin = lazy(() => import('../pages/VictimeForm/Login/Login'))
const OtpConformation = lazy(() => import('../pages/VictimeForm/Login/OtpConformation'))
const MyCaseSingleView = lazy(() => import('../pages/VictimeForm/Pages/MyCasesSingleView'))

const PublicRoutes = [
    {
        path: '/public',
        component: () => <div>Public Page</div>,
    },
    {
        path: '/victim_form',
        component: () => <VictimFormLogin />,
    },
    {
        path: '/victim_form_otp_conformation/:id',
        component: () => <OtpConformation />,
    },
        {
        path: '/cases_single_view',
        component: () =>
            <VictimProtectedRoute>
                <MyCaseSingleView />
            </VictimProtectedRoute>,
    },

]

export default PublicRoutes 